import { getRepairsStatusesConstants } from "../constants";
import { alertActions } from "./alert.actions";
import { entityDataGenerator } from "../helpers";

export const getRepairsStatusesActions = {
  getStatuses,
};

function getStatuses(statusRequested) {
  //statusRequest param idenify which statused we are querying (ie bombardier, pbh..)
  return (dispatch) => {
    dispatch(request());
    entityDataGenerator
      .getStatuses(statusRequested)
      .then((OrdersStatuses) => {
        dispatch(success(OrdersStatuses));
      })
      .catch((err) => {
        dispatch(failure(err.toString()));
        httpErrorHandler(err);
      });
  };

  function request() {
    return { type: getRepairsStatusesConstants.STATUSES_REPAIRS_REQUEST };
  }
  function success(orders) {
    return {
      type: getRepairsStatusesConstants.STATUSES_REPAIRS_SUCCESS,
      orders,
    };
  }
  function failure(error) {
    return {
      type: getRepairsStatusesConstants.STATUSES_REPAIRS_FAILURE,
      error,
    };
  }
}

function httpErrorHandler(error) {
  return (dispatch) => {
    let httpStatus =
      error.response != undefined ? error.response.status : 404;
    if (httpStatus >= 500 || httpStatus == 404) {
      // Added to handle error(s)
      dispatch(alertActions.error("Network Connection Error."));
    } else if (httpStatus == 401) {
      userActions.msalLogout();
      dispatch({ type: userConstants.LOGOUT });
    } else {
      dispatch(failure(error.toString()));
      dispatch(alertActions.error(error.toString()));
    }
  };
}
